import { forwardRef } from 'react';
import { Search } from 'react-bootstrap-icons';

import { Input, InputProps, InputRef, Typography } from 'antd';

import styled, { css } from '@/styled';

const SearchInput = forwardRef<InputRef, InputProps>(({ ...props }, ref) => (
  <CustomInput
    ref={ref}
    placeholder={'Procurar cursos e autores'}
    prefix={<Search />}
    suffix={<Typography>CTRL + K</Typography>}
    {...props}
  />
));

const CustomInput = styled(Input)`
  ${({ theme }) => css`
    width: 420px;
    max-width: 100%;
    font-size: ${theme.space.pxToRem(16)};
    color: ${theme.colorText};
    padding: ${theme.space.spacing(2, 6, 2, 0)};
    background: ${theme.variables.bgComponentsContainer};

    svg {
      color: ${theme.colorText};
      margin: ${theme.space.spacing(0, 2, 1, 3)};
      font-size: ${theme.space.pxToRem(12)};
    }

    .ant-input-suffix article {
      color: ${theme.colorTextQuaternary};
    }
  `}
`;

export default SearchInput;
